import FilterAlt from "@mui/icons-material/FilterAlt";
import Inventory from "@mui/icons-material/Inventory";
import Receipt from "@mui/icons-material/Receipt";
import Security from "@mui/icons-material/Security";
import Block from "@mui/icons-material/Block";
import Store from "@mui/icons-material/Store";
import Settings from "@mui/icons-material/Settings";
import Warehouse from "@mui/icons-material/Warehouse";
import BarChart from "@mui/icons-material/BarChart";
import Money from "@mui/icons-material/Money";
import { ResourceProps } from "@refinedev/core";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import { NotificationsActive, PriceChange } from "@mui/icons-material";
import React from "react";

type NavigationItem = {
  name: string;
  list?: string;
  icon: React.ReactElement;
  children?: NavigationItem[];
};

const navigationItems: NavigationItem[] = [
  {
    name: "orders",
    list: "/",
    icon: <Receipt />,
  },
  {
    name: "inventory-management",
    list: "/",
    icon: <Inventory />,
    children: [
      {
        name: "inventory",
        list: "inventory/",
        icon: <FormatListBulletedIcon fontSize="small" />,
      },
    ],
  },
  {
    name: "store-security",
    list: "/",
    icon: <Security />,
    children: [
      {
        name: "filters",
        list: "store-security/filters",
        icon: <FilterAlt fontSize="small" />,
      },
      {
        name: "restrictions",
        list: "store-security/restrictions",
        icon: <Block fontSize="small" />,
      },
    ],
  },
  {
    name: "stores",
    list: "/",
    icon: <Store />,
    children: [
      {
        name: "store-settings",
        list: "/store/store-settings",
        icon: <Settings fontSize="small" />,
      },
      {
        name: "pricing-settings",
        list: "/store/pricing-settings",
        icon: <Money fontSize="small" />,
      },
      {
        name: "competition-settings",
        list: "/store/competition-settings",
        icon: <PriceChange fontSize="small" />,
      },
      {
        name: "mail-notification",
        list: "/store/mail-notification",
        icon: <NotificationsActive fontSize="small" />,
      },
    ],
  },

  {
    name: "reports",
    list: "/",
    icon: <BarChart />,
  },
  {
    name: "warehouse",
    list: "/warehouse",
    icon: <Warehouse />,
  },
];

// Converts navigation items to ResourceProps list from Refine
export const getResources = () => {
  return navigationItems.reduce<ResourceProps[]>((acc, item) => {
    acc.push({
      name: item.name,
      list: item.list,
      meta: {
        icon: item.icon,
      },
    });

    if (item.children) {
      const childResources = item.children.map((child) => ({
        name: child.name,
        list: child.list,
        meta: {
          parent: item.name,
          icon: child.icon,
        },
      }));

      acc.push(...childResources);
    }

    return acc;
  }, []);
};
